import a11yIIBScreenReaderService, { A11yForIIBScreenReaderIteration } from '../../services/a11yIIBScreenReaderService';
import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const tableOfContentsSelector = {
    selectIsNavigationAllowed(settings) {
        if (sessionReader.isOneWayNavigationSupportedContext() && settingsReader.isOneWayNavigationEnabled()) {
            return false;
        }

        return settingsReader.allowNavigateBack(settings) || settingsReader.showAssessmentTrack(settings);
    },

    showTOCFiltersInMainLandmark() {
        return a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported(
            A11yForIIBScreenReaderIteration.v5,
        );
    },

    selectProps(state) {
        const {
            assessment,
            api,
            itemFlag: { flaggedItems },
            response,
            settings,
            toc,
            ui,
        } = state;

        return {
            assessment,
            flaggedItems,
            isNavigationAllowed: this.selectIsNavigationAllowed(settings),
            isPreloading: !!(api?.isPreloading),
            numberOfQuestions: toc.numberOfQuestions,
            questionsFilter: toc.filter,
            response,
            settings,
            ui,
            showTOCFiltersInMainLandmark: this.showTOCFiltersInMainLandmark(),
        };
    },
};

export default tableOfContentsSelector;
